import React from "react";
import usePaymentPageExperimentValue from "../hooks";
import PaymentHeader from "./PaymentHeader";

interface ContainerProps {
  children: React.ReactNode;
  onBack: () => void;
  backLabel?: string;
}

const PageContainer: React.FC<ContainerProps> = ({
  children,
  onBack,
  backLabel,
}) => {
  const { titleText, bodyText } = usePaymentPageExperimentValue();

  return (
    <div className="flex flex-col min-h-screen pb-[80px] bg-background">
      <PaymentHeader
        titleText={titleText}
        bodyText={bodyText}
        onBack={onBack}
        backLabel={backLabel}
      />
      {children}
    </div>
  );
};

export default PageContainer;
